import React from 'react'

import { ReactComponent as CrossIcon } from 'assets/images/icons/cross-icon.svg'
import { ReactComponent as SearchIcon } from 'assets/images/icons/search-icon.svg'
import { Icon } from 'components/uikit/Icon/Icon'

import styles from './Search.module.scss'

interface Props {
  searchInput: string
  setSearchInput: (value: string) => void
  placeholderText: string
  handleSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

const Search = ({ searchInput, setSearchInput, placeholderText, handleSearchChange }: Props) => {
  return (
    <div className={styles.searchWrapper}>
      <Icon icon={SearchIcon} aria-label="Search icon" className={styles.searchIcon} color="#4d5358" />
      <input
        name="search"
        placeholder={placeholderText}
        value={searchInput}
        required
        className={styles.input}
        onChange={handleSearchChange}
      />
      {searchInput.length !== 0 && (
        <button
          type="button"
          className={styles.clearButton}
          onClick={() => {
            setSearchInput('')
          }}
          aria-label="Clear search"
        >
          <Icon icon={CrossIcon} aria-label="Clear icon" color="#8b919a" />
        </button>
      )}
    </div>
  )
}

export default Search
